import { createCn } from "cn/config";

/**
 * `cn`, taught the type scale.
 *
 * The nine steps live in `globals.css` as plain classes named `text-*`, which
 * is the prefix Tailwind already owns. `cn` resolves `text-*` by asking whether
 * what follows is a font size it knows: `text-sm` is, so it lands in the
 * font-size group; `text-body-sm` is not, so it falls through to text-COLOR.
 * Put a colour beside it — `cn("text-body-sm", "text-ink-headline")` — and the
 * two land in the same group, the last one wins, and the size is dropped with
 * no error and no warning.
 *
 * The element then inherits its size from an ancestor, which is why the admin
 * top bar broke: fifteen links rendering at the root font size, wrapping a bar
 * built for one line. Seventeen call sites across admin and partner had the
 * same shape.
 *
 * Declaring the steps here is the fix for the category, not for the seventeen.
 * Rename a step or add one and this list is what has to change with it.
 */
export const cn = createCn({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display",
            "h1",
            "h2",
            "h3",
            "h4",
            "lead",
            "body",
            "body-sm",
            "caption",
          ],
        },
      ],
    },
  },
});
